<div class="flex">
  <p-dropdown
    [(ngModel)]="_assigneeId"
    [options]="options"
    appendTo="body"
    autoWidth="false"
    placeholder="Assign a User"
    [filter]="true"
    styleClass="bg-gray-100 border-round-lg p-1"
    (onChange)="assignedUserChange.emit(assignee)"
  >
    <ng-template let-user pTemplate="selectedItem">
      Assigned to <span class="bold-text">{{ user.label }}</span>
    </ng-template>
    <ng-template let-user pTemplate="item">
      {{ user.label }}
    </ng-template>
  </p-dropdown>
  <button
    *ngIf="assigneeId"
    (click)="unassignUser()"
    class="ml-1 border-round-lg ui-button-tertiary cursor-pointer"
  >
    Unassign
  </button>
</div>
